<ion-modal #modalDrawer
    class="marv_drawer" 
    [class.small]="this.sizeDrawer === 'small'"
    [class.medium]="this.sizeDrawer === 'medium'"
    [class.big]="this.sizeDrawer === 'big'"   
    [class.marv_drawer_hide]="this.hideDrawer"   
    [showBackdrop]="this.showBackdrop"
    [backdropDismiss]="this.backdropDismiss"
    [canDismiss]="this.canDismissModal.bind(this)"
    (didDismiss)="this.onDidDismissModal($event)" 
    [enterAnimation]="this.slideFromRight.enter"
    [leaveAnimation]="this.slideFromRight.leave"
    >   
    <ng-template>
        <ion-content [class.ion-padding]="!this.noPadding">
            <div class="marv_drawer_content" >
                @if(this.showCloseButton){
                    <div class="btn_close_drawer">
                        <ion-icon name="close-outline" (click)="this.close()"></ion-icon>
                    </div>
                }
                <div class="marv_drawer_template" >
                    <ng-content></ng-content>    
                </div>
            </div>
        </ion-content>
    </ng-template>
</ion-modal>